import React from 'react';

import { RouteComponentProps } from '@reach/router';
import { PublicSetWithEWebinarFragment } from '$/GraphQL/schema/types';
import { ForceUseBundleComponent, getPublicSet } from '$/utils/ssr';
import WebinarPage from '$/pages/webinar';
import NoWebinar from '$/components/pages/404/NoWebinar';

export async function getServerData({ params }: { params: { '*': string } }) {
  const setId = params['*'].split('/')[0];
  let set;
  try {
    set = await getPublicSet(setId);
  } catch (error) {
    console.log('getServerData error:', { setId, error });
  }

  return {
    props: { set },
  };
}

interface EWebinarSetProps {
  serverData: { set: PublicSetWithEWebinarFragment };
}

export default function EWebinarSet({
  serverData,
  location,
}: RouteComponentProps & EWebinarSetProps) {
  const { set } = serverData;
  if (!set)
    return (
      <>
        <NoWebinar extensions={{ code: 'NOT_FOUND' }} />
        <ForceUseBundleComponent />
      </>
    );
  return <WebinarPage pageContext={{ set }} location={location} />;
}
